<template>
    <Bill :menuId="page.id" 
        :options="getOptions()" 
        :queryConditionPaneComponent="getQueryConditionPane()"
        :queryResultWorker = "getQueryResultWorker()"
        :editorComponent="getEditorComponent()"
        :queryResultKeyInfo = "getQueryResultKeyInfo()"
        :emptyRec="getEmptyRec()"
        :editorButtonPaneComponent="getEditorButtonPane()"
    >
    </Bill>
</template>

<script>

import Bill from '../../../../base/bill/Bill.vue';
import Mode from '../../../../base/bill/Mode.js';
import Worker from './QueryResultWorker.js';

export default {
    name: 'SmMarketPrintcouponBackendSend',
    props:['page'],
    components: {
        'Bill':Bill,
    },
    data () {
        return {
            queryConditionPaneComponent:null,
            queryResultPaneComponent:null, 
            editorButtonPaneComponent:null,
            editorComponent:null,
        }
    },
    methods:{
        getQueryConditionPane(){
            if(!this.queryConditionPaneComponent)
                this.queryConditionPaneComponent = (require('@/views/sm/market/printcoupon/backendSend/QueryConditionPane.vue').default);
            return this.queryConditionPaneComponent;
        },
        getQueryResultWorker(){
            return Worker;
        },
        getOptions(){
            return {
            };
        },
        getEditorComponent(){
            if(!this.editorComponent)
                this.editorComponent = (require('@/views/sm/market/printcoupon/backendSend/Editor.vue').default);
            return this.editorComponent;
        },
         getEditorButtonPane(){
            if(!this.editorButtonPaneComponent)
                this.editorButtonPaneComponent = (require('@/views/sm/market/printcoupon/backendSend/EditorButtonPane.vue').default);
            return this.editorButtonPaneComponent;
        },
        getQueryResultKeyInfo(){
            return {
                itemKeyName:"id",
                emptyItemKeyValue:-1,
            };
        },
        getEmptyRec(){
            return {
                id:-1,
                shopId:'',
                shopName:'',
                sktno:'',
                fphm:'',
                operId:-1,
                operName:'',
                createTime:'',

                couponAmount:'',
                couponNo:'',
                couponName:'',

                coupons:[],
                couponActivitys:[],
                couponActivity:{},
                couponActivityId:'',
                couponActivityName:'',
                couponActivityStartDate:'',
                couponActivityEndDate:'',
                
            };
        }
    },
    created(){
        console.log('backend send coupon page created');
        console.log(this.page);
    },
    mounted(){
        console.log('backend send coupon page mounted');
        console.log(this.page);
    }
}

</script>

<style scoped>
</style>